import PublicPolicyStudio from "../../policy-studio/PublicPolicyStudio"
import { WazToolbar } from "../toolbar/WazToolbar"
import "./WazPolicyStudio.css"


type WazPolicyStudioProps = {

}

export const WazPolicyStudio = ({} : WazPolicyStudioProps) => {


    return  (
         <div className="wazawan-ps">
            <WazToolbar />
            <PublicPolicyStudio />
        </div>
    
    )
}